import { useDispatch, useSelector } from "react-redux";
import { setFilter, setSort } from "../../features/Blogs/blogsSlice";

export default function Sidebar() {
  const { filter, sort } = useSelector((state) => state.blogs);
  const dispatch = useDispatch();

  const handleSelectSort = (e) => {
    dispatch(setSort(e.target.value));
  };

  const handleFilterChange = (event) => {
    dispatch(setFilter(event.target.value));
  };

  return (
    <aside>
      <div className="sidebar-items">
        <div className="sidebar-content">
          <h4>Sort</h4>
          <select
            name="sort"
            id="lws-sort"
            value={sort}
            onChange={handleSelectSort}
            className="w-full max-w-[150px] border-2 rounded-md text-gray-500"
          >
            <option value="">Default</option>
            <option value="newest">Newest</option>
            <option value="most_liked">Most Liked</option>
          </select>
        </div>
        <div className="sidebar-content">
          <h4>Filter</h4>
          <div className="radio-group">
            {/* handle filter on button click */}
            <div>
              <input
                type="radio"
                name="filter"
                id="lws-all"
                value="all"
                defaultChecked={filter === "all"}
                onChange={handleFilterChange}
                className="radio"
              />
              <label htmlFor="lws-all">All</label>
            </div>
            <div>
              <input
                type="radio"
                name="filter"
                id="lws-saved"
                value="saved"
                defaultChecked={filter === "saved"}
                onChange={handleFilterChange}
                className="radio"
              />
              <label htmlFor="lws-saved">Saved</label>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
